import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "my-10 mb-20 pb-10 md:pb-0" }
const _hoisted_2 = { class: "appFont flex items-center space-x-2" }
const _hoisted_3 = { class: "bg-gray-50 dark:bg-gray-800 py-3 px-4 my-2 rounded-2xl shadow-xs" }
const _hoisted_4 = {
  key: 0,
  class: "p-3"
}
const _hoisted_5 = { class: "text-3xl sm:text-4xl font-bold titleFont mt-2" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "border-t-4 border-t-gray-200 dark:border-t-gray-900 rounded-lg my-3" }, null, -1)
const _hoisted_8 = { class: "text-xl sm:text-2xl font-bold titleFont mt-2" }
const _hoisted_9 = { class: "mt-5" }
const _hoisted_10 = { class: "text-xl sm:text-2xl font-bold titleFont mt-2" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "border-t-4 border-t-gray-200 dark:border-t-gray-900 rounded-lg my-3" }, null, -1)
const _hoisted_13 = { class: "text-xl sm:text-2xl font-bold titleFont mt-2" }
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "p-3"
}
const _hoisted_18 = { class: "text-3xl sm:text-4xl font-bold titleFont mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_UserProfile = _resolveComponent("UserProfile")!
  const _component_UploadTypes = _resolveComponent("UploadTypes")!
  const _component_MusicPlayer = _resolveComponent("MusicPlayer")!
  const _component_QuestionMark = _resolveComponent("QuestionMark")!
  const _component_BrowserLink = _resolveComponent("BrowserLink")!
  const _component_Tippy = _resolveComponent("Tippy")!
  const _component_SpinnerIcon = _resolveComponent("SpinnerIcon")!
  const _component_MusicSelector = _resolveComponent("MusicSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('Anonymous')), 1),
      _createVNode(_component_Switch, {
        checked: _ctx.is_anonymous,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.is_anonymous = !_ctx.is_anonymous))
      }, null, 8, ["checked"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UserProfile, {
        user: _ctx.user(),
        posted_at: new Date(),
        is_anonymous: _ctx.is_anonymous
      }, null, 8, ["user", "posted_at", "is_anonymous"]),
      (!_ctx.contentSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!_ctx.hasUploaded)
              ? (_openBlock(), _createBlock(_component_UploadTypes, {
                  key: 0,
                  onChanged: _ctx.selectContent
                }, null, 8, ["onChanged"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.files, (file, name) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                    (file !== null)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (name == 'music')
                            ? (_openBlock(), _createBlock(_component_MusicPlayer, {
                                key: 0,
                                music: file,
                                post_created_at: "play_no_date"
                              }, null, 8, ["music"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("h3", _hoisted_5, [
                _withDirectives(_createElementVNode("textarea", {
                  spellcheck: "false",
                  rows: "1",
                  placeholder: _ctx.$t('Title') + '... (' + _ctx.$t('Min {0} letter', [15]) + ')',
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resize($event))),
                  class: _normalizeClass(["bg-gray-50 dark:bg-gray-800 w-full resize-none", {'text-yellow-400 dark:text-yellow-300':  _ctx.title.length > 70 && _ctx.title.length <= 85,'text-orange-400': _ctx.title.length > 85 && _ctx.title.length <= 100, 'text-red-500 dark:text-red-400': _ctx.title.length > 100 || _ctx.title.length < 10}]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.title) = $event))
                }, null, 42, _hoisted_6), [
                  [_vModelText, _ctx.title]
                ])
              ]),
              _hoisted_7,
              _createElementVNode("h5", _hoisted_8, [
                _createElementVNode("span", {
                  class: _normalizeClass({'text-yellow-400 dark:text-yellow-300':  _ctx.title.length > 70 && _ctx.title.length <= 85,'text-orange-400': _ctx.title.length > 85 && _ctx.title.length <= 100, 'text-red-500 dark:text-red-400': _ctx.title.length > 100 || _ctx.title.length < 10})
                }, _toDisplayString(_ctx.title.length), 3),
                _createTextVNode(" / 100 " + _toDisplayString(_ctx.$t('letter')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Description')) + " ", 1),
                  _createVNode(_component_Tippy, {
                    content: _ctx.$t('How to write a good description?')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BrowserLink, {
                        href: _ctx.$supportLink('/good-post-description'),
                        class: "transition duration-150 text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-600"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_QuestionMark)
                        ]),
                        _: 1
                      }, 8, ["href"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  spellcheck: "false",
                  rows: "1",
                  placeholder: _ctx.$t('Description') + '... (' + _ctx.$t('Max {0} letter', [500]) + ')',
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resize($event, 2))),
                  class: "mt-2 bg-gray-50 dark:bg-gray-800 w-full resize-none text-gray-700 dark:text-gray-400",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.description) = $event))
                }, null, 40, _hoisted_11), [
                  [_vModelText, _ctx.description]
                ])
              ]),
              _hoisted_12,
              _createElementVNode("h5", _hoisted_13, [
                _createElementVNode("span", {
                  class: _normalizeClass({'text-orange-400': _ctx.description.length > 450 && _ctx.description.length <= 500, 'text-red-500 dark:text-red-400': _ctx.description.length > 500})
                }, _toDisplayString(_ctx.description.length), 3),
                _createTextVNode(" / 500 " + _toDisplayString(_ctx.$t('letter')), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
                  disabled: (!_ctx.canSubmit || !_ctx.filesOk) || _ctx.processing,
                  class: "block w-full transition duration-150 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-900 dark:hover:bg-gray-700 p-3 text-center cursor-pointer appFont disabled:cursor-not-allowed disabled:opacity-50"
                }, [
                  (!_ctx.processing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('Post')), 1))
                    : (_openBlock(), _createBlock(_component_SpinnerIcon, { key: 1 }))
                ], 8, _hoisted_15)
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_18, [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.contentSelectContent.name)) + " ", 1),
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.contentSelectContent.icon)))
              ]),
              (_ctx.contentSelectContent.key === 'music')
                ? (_openBlock(), _createBlock(_component_MusicSelector, {
                    key: 0,
                    onOnSelected: _ctx.musicSelected
                  }, null, 8, ["onOnSelected"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.contentSelect = false;_ctx.contentSelectContent = {}}),
              type: "button",
              class: "mt-3 block w-full transition duration-150 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-900 dark:hover:bg-gray-700 p-3 text-center cursor-pointer appFont disabled:cursor-not-allowed disabled:opacity-50"
            }, _toDisplayString(_ctx.$t('Back')), 1)
          ]))
    ])
  ]))
}